import React, { useState } from "react";
import FeedbackModal from "./../FeedbackModal";


const FEATURES = [
  "Multi-Timeframe Signal Engine",
  "EMA / RSI /Stoch RSI / ADX / VWAP / ICT structure Levels / Support/Resistance",
  "Risk-Managed Auto Execution",
  "Enterprise-Level Security"
];

const FeaturesSection = () => {
    const [showFeedback, setShowFeedback] = useState(false);
  
  return (
    <section className="section light">
      <h2 className="section-title">Why SignalFly?</h2>

      <div className="card-grid">
        {FEATURES.map((f, i) => (
          <div key={i} className="glass-card">
            {f}
          </div>
        ))}
      </div>

      <button
        onClick={() => setShowFeedback(true)}
      >
        💬 Feedback
      </button>

      {showFeedback && (
        <FeedbackModal
          onClose={() => setShowFeedback(false)}
          sourcePage="FeaturesSection"
        />
      )}

    </section>
  );
};

export default FeaturesSection;
